import {styled, TableRow} from "@mui/material"

const HoverTableRow = styled(TableRow)(({theme}) => ({
	'&:hover': {
		backgroundColor: theme.palette.action.hover,
	},
}))

export default HoverTableRow